const ANONYMOUS_EMAIL_SUFFIX = "@anonymous.local";

/**
 * Who submitted a response. Anonymous QR visitors are stored with a placeholder
 * `@anonymous.local` user, which is never treated as a linked person or shown.
 */
export const getRespondent = (response, anonymousName = "Anonymous Visitor") => {
  const isAnonymousQrVisitor = response.user?.email?.endsWith(ANONYMOUS_EMAIL_SUFFIX);
  const hasLinkedUser = Boolean(response.user && response.userId && !isAnonymousQrVisitor);
  const hasFollowUpInfo = Boolean(response.followUpEmail || response.followUpName);
  const displayName = hasLinkedUser
    ? `${response.user.firstName || ""} ${response.user.lastName || ""}`.trim()
    : response.followUpName || anonymousName;
  const displayEmail = hasLinkedUser ? response.user.email : response.followUpEmail || null;

  return { hasLinkedUser, hasFollowUpInfo, displayName, displayEmail };
};

export const profilePath = (response) => `/admin/people/${response.userId}/profile`;
